module.exports = __webpack_public_path__ + "static/media/nice-comment.2cfde5ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/recorded/nice-comment.png
// module id = 2094
// module chunks = 4